import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Row, Col, Select, Input, Typography, Tag } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { AddsContainer } from './common';
import WorkOrderDetailsContext from '../../../containers/WorkOrder/WorkOrderDetailsContext';

import IssueObject, {
  getPriorityTagColor,
  getPriorityTagDescription,
} from 'stores/Classes/IssueObject';

const { Option } = Select;
const { Text } = Typography;

const IconCol = styled(Col)`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function Defect({
  itemKey,
  item,
  defects,
  deleteSubItem,
  changeSubItem,
  changeItemProperty,
}) {
  const contextValue = useContext(WorkOrderDetailsContext);

  const {
    state: { assetDefects },
  } = contextValue;

  const handleChange = (value) => {
    const defects = assetDefects
      .filter((d) => value.includes(String(d.id)))
      .map((defect) => {
        return {
          key: defect.key,
          id_defect: defect.id,
          isResolved: defect.isResolved,
          dvirId: defect.dvirId,
          name: `Defect ${defect.id}`,
          comment: defect.comment || '',
        };
      });
    changeItemProperty(itemKey, 'defects', defects);
  };

  const validDefects = defects.filter((d) => d.id_defect);
  return (
    <Row style={{ marginTop: '10px' }}>
      <Col span={23}>
        <Select
          style={{ width: '100%' }}
          onChange={handleChange}
          mode="multiple"
          {...(validDefects.length > 0 && {
            value: validDefects.map((d) => d.id_defect),
          })}
        >
          {assetDefects.map((defect, index) => {
            return (
              <Option
                key={defect.id}
                value={defect.id}
                stile={{
                  lineHeight: '20px',
                }}
              >
                <Tag
                  color={defect.isResolved ? 'green' : 'red'}
                  style={{ background: 'white' }}
                >
                  {defect.isResolved ? 'Resolved' : 'Unresolved'}
                </Tag>
                {defect.comment}
              </Option>
            );
          })}
        </Select>
      </Col>
      <IconCol span={1}>
        <DeleteOutlined
          style={{ fontSize: '20px', color: 'red' }}
          onClick={deleteSubItem}
        />
      </IconCol>
    </Row>
  );
}

export default Defect;
